(function () {
  if (window.__hsw5CollectionStandaloneReady) return;
  window.__hsw5CollectionStandaloneReady = true;

  function getSectionRoot(element) {
    return element && element.closest ? element.closest('[data-hsw5-collection-section]') : null;
  }

  function getProductFilterFromHash(filterRoot) {
    var hashValue = window.location.hash.slice(1);
    if (!hashValue) return null;

    try {
      hashValue = decodeURIComponent(hashValue);
    } catch (error) {
      return null;
    }

    var matchingButton = Array.prototype.find.call(
      filterRoot.querySelectorAll('[data-hsw5-product-filter]'),
      function (button) {
        return button.dataset.hsw5ProductFilter === hashValue;
      }
    );

    return matchingButton ? matchingButton.dataset.hsw5ProductFilter : null;
  }

  function updateProductFilterHash(productType) {
    var selectedProduct = productType || 'all';
    if (window.location.hash.slice(1) === selectedProduct) return;

    var url = new URL(window.location.href);
    url.hash = selectedProduct;
    window.history.pushState({}, '', url.toString());
  }

  function applyProductFilter(filterRoot, productType) {
    var selectedProduct = productType || 'all';
    var sectionRoot = getSectionRoot(filterRoot);
    if (!sectionRoot) return;

    filterRoot.querySelectorAll('[data-hsw5-product-filter]').forEach(function (button) {
      var isActive = button.dataset.hsw5ProductFilter === selectedProduct;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    sectionRoot.querySelectorAll('[data-hsw5-collection-results]').forEach(function (results) {
      var visibleCards = 0;

      results.querySelectorAll('[data-hsw5-collection-card]').forEach(function (card) {
        var gridItem = card.closest('.hsw5-collection-grid__item') || card;
        var shouldShow = selectedProduct === 'all' || card.dataset.hsw5CollectionProduct === selectedProduct;
        if (gridItem.hidden !== !shouldShow) gridItem.hidden = !shouldShow;
        if (shouldShow) visibleCards += 1;
      });

      var emptyMessage = results.querySelector('[data-hsw5-collection-empty]');
      if (emptyMessage) emptyMessage.hidden = visibleCards !== 0;
    });
  }

  function initializeScrollableRow(viewport) {
    var row = viewport.querySelector('.collection-filters--hsw5__row');
    if (!row || row.dataset.hsw5DragReady === 'true') return;
    row.dataset.hsw5DragReady = 'true';

    var layoutFrame = 0;
    var lastOverflow = null;

    function updateLayout() {
      layoutFrame = 0;
      var isOverflowing = row.scrollWidth > row.clientWidth + 1;
      if (isOverflowing !== lastOverflow) {
        lastOverflow = isOverflowing;
        row.classList.toggle('is-overflowing', isOverflowing);
        viewport.classList.toggle('is-overflowing', isOverflowing);
      }
      if (!isOverflowing && row.scrollLeft !== 0) row.scrollLeft = 0;
    }

    function scheduleLayout() {
      if (layoutFrame) return;
      layoutFrame = window.requestAnimationFrame(updateLayout);
    }

    function scrollToCurrentCollection() {
      if (!row.classList.contains('is-overflowing')) return;
      var currentPill = row.querySelector('[aria-current="page"], [data-hsw5-product-filter][aria-pressed="true"]');
      if (!currentPill) return;

      var visibleLeft = row.scrollLeft;
      var visibleRight = visibleLeft + row.clientWidth;
      var pillLeft = currentPill.offsetLeft;
      var pillRight = pillLeft + currentPill.offsetWidth;
      var isFullyVisible = pillLeft >= visibleLeft && pillRight <= visibleRight;
      if (isFullyVisible) return;

      var centeredLeft = currentPill.offsetLeft - ((row.clientWidth - currentPill.offsetWidth) / 2);
      var maximumLeft = Math.max(0, row.scrollWidth - row.clientWidth);
      row.scrollLeft = Math.max(0, Math.min(centeredLeft, maximumLeft));
    }

    var pointerDown = false;
    var dragMoved = false;
    var suppressClick = false;
    var startX = 0;
    var startScrollLeft = 0;
    var activePointerId = null;

    row.addEventListener('pointerdown', function (event) {
      var isDesktopPointer = event.pointerType === 'mouse' || event.pointerType === 'pen';
      var isDesktopViewport = window.matchMedia('(min-width: 861px)').matches;
      if (!isDesktopViewport || !isDesktopPointer || event.button !== 0 || !row.classList.contains('is-overflowing')) return;

      pointerDown = true;
      dragMoved = false;
      startX = event.clientX;
      startScrollLeft = row.scrollLeft;
      activePointerId = event.pointerId;
    });

    row.addEventListener('pointermove', function (event) {
      if (!pointerDown) return;
      var distance = event.clientX - startX;
      if (!dragMoved && Math.abs(distance) < 4) return;

      dragMoved = true;
      row.classList.add('is-dragging');
      if (!row.hasPointerCapture(activePointerId)) row.setPointerCapture(activePointerId);
      row.scrollLeft = startScrollLeft - distance;
      event.preventDefault();
    });

    function finishDrag(event) {
      if (!pointerDown) return;
      pointerDown = false;
      suppressClick = dragMoved;
      row.classList.remove('is-dragging');
      if (row.hasPointerCapture(event.pointerId)) row.releasePointerCapture(event.pointerId);
      activePointerId = null;
      window.setTimeout(function () { suppressClick = false; }, 0);
    }

    row.addEventListener('pointerup', finishDrag);
    row.addEventListener('pointercancel', finishDrag);
    row.addEventListener('dragstart', function (event) { event.preventDefault(); });
    row.addEventListener('click', function (event) {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(scheduleLayout);
      resizeObserver.observe(row);
      resizeObserver.observe(viewport);
    } else {
      window.addEventListener('resize', scheduleLayout);
    }

    scheduleLayout();
    window.requestAnimationFrame(function () {
      updateLayout();
      scrollToCurrentCollection();
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        scheduleLayout();
        window.requestAnimationFrame(scrollToCurrentCollection);
      });
    }
  }

  function initializeSection(sectionRoot) {
    if (!sectionRoot) return;


    sectionRoot.querySelectorAll('[data-hsw5-collection-filters]').forEach(function (filterRoot) {
      filterRoot.querySelectorAll('.collection-filters--hsw5__viewport').forEach(initializeScrollableRow);
      var activeButton = filterRoot.querySelector('[data-hsw5-product-filter].is-active');
      var hashedProductFilter = getProductFilterFromHash(filterRoot);
      if (hashedProductFilter) {
        applyProductFilter(filterRoot, hashedProductFilter);
      } else if (activeButton) {
        applyProductFilter(filterRoot, activeButton.dataset.hsw5ProductFilter);
      }
    });
  }

  function initializeSections(scope) {
    if (scope.matches && scope.matches('[data-hsw5-collection-section]')) {
      initializeSection(scope);
    }
    scope.querySelectorAll('[data-hsw5-collection-section]').forEach(initializeSection);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-hsw5-product-filter]');
    if (button) {
      var filterRoot = button.closest('[data-hsw5-collection-filters]');
      if (filterRoot) {
        applyProductFilter(filterRoot, button.dataset.hsw5ProductFilter);
        updateProductFilterHash(button.dataset.hsw5ProductFilter);
      }
      return;
    }

    var moreButton = event.target.closest('[data-hsw5-group-more]');
    if (!moreButton) return;

    var group = moreButton.closest('[data-hsw5-collection-group]');
    if (!group) return;

    var pageSize = parseInt(group.dataset.hsw5GroupPageSize, 10);
    if (!Number.isFinite(pageSize) || pageSize < 1) pageSize = 8;

    var hiddenCards = Array.prototype.slice.call(group.querySelectorAll('[data-hsw5-group-extra][hidden]'));
    hiddenCards.slice(0, pageSize).forEach(function (card) { card.hidden = false; });
    moreButton.hidden = hiddenCards.length <= pageSize;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeSections(document); });
  } else {
    initializeSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeSections(event.target);
  });

  window.addEventListener('popstate', function () {
    document.querySelectorAll('[data-hsw5-collection-section]').forEach(function (sectionRoot) {
      sectionRoot.querySelectorAll('[data-hsw5-collection-filters]').forEach(function (filterRoot) {
        applyProductFilter(filterRoot, getProductFilterFromHash(filterRoot) || 'all');
      });
    });
  });
})();
